export default {
  state: {
    appName: '个人博客', // 应用名称
    themeColor: '#0e47a1', // 主题颜色
    oldThemeColor: '#0e47a1', // 上一次主题颜色
    collapse: false, // 导航栏收缩状态
    tabPage: false, // 是否开启标签页
    headerMenu: true, // 是否使用头标题
    loginOpen: false, // 是否打开登录页
    roleCheck: false, // 是否开启角色检查
    sso: false, // 是否单点登录
    ssoType: 'oauth2', // cas|oauth2
    ssoLogin: 'http://127.0.0.1:6100/authc/oauth/authorize?client_id=nucleic-acid&response_type=code&redirect_uri=http://127.0.0.1:4710/login',
    ssoExit: 'http://127.0.0.1:6100/authc/logout' // 单点退出地址
  },
  getters: {
    collapse(state) { // 对应着上面state
      return state.collapse
    }
  },
  mutations: {
    onCollapse(state) { // 改变收缩状态
      state.collapse = !state.collapse
    },
    setThemeColor(state, themeColor) { // 改变主题颜色
      state.oldThemeColor = state.themeColor
      state.themeColor = themeColor
    },
    // 登录页打开
    setLoginOpen(state, isOpen) {
      state.loginOpen = isOpen
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js